import { render } from "./kantuFooter.vue?vue&type=template&id=75f047c6&scoped=true&ts=true"
import script from "./kantuFooter.vue?vue&type=script&lang=ts"
export * from "./kantuFooter.vue?vue&type=script&lang=ts"

import "./kantuFooter.vue?vue&type=style&index=0&id=75f047c6&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f047c6"]])